import { useScrollVisible } from "./useScrollVisible";
import { NatureIllustration } from "./NatureIllustration";

export function About() {
  const { ref, visible } = useScrollVisible(0.2);

  return (
    <section id="ueber-mich" className="relative py-24 md:py-32 bg-sand-100">
      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div className="grid md:grid-cols-[1fr_1.15fr] gap-12 md:gap-20 items-center">
          <div
            className={`relative transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="relative aspect-[4/5] overflow-hidden bg-sand-200 rounded-[2rem]">
              <NatureIllustration className="w-full h-full" />
            </div>
            <div className="hidden md:block absolute -bottom-6 -right-6 w-32 h-32 border border-sage-700/30 rounded-2xl" />
          </div>

          <div
            className={`transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-px bg-sage-700" />
              <span className="text-sage-700 text-[11px] tracking-[0.35em] uppercase font-medium">
                Über mich
              </span>
            </div>

            <h2 className="font-display text-4xl md:text-5xl text-stone-900 leading-[1.08] mb-8 tracking-tight font-semibold">
              Begleitung mit Ruhe
              <br />
              und Achtsamkeit.
            </h2>

            <div className="space-y-5 text-stone-700 leading-relaxed font-light text-base">
              <p>
                Mein Name ist <span className="text-stone-900 font-medium">Christine Pfeifle-Rauch</span>.
                Ich bin seit 2005 als Grundschullehrerin tätig. Von 2023 bis 2025 machte
                ich nebenberuflich die Ausbildung zur pädagogischen Kinesiologin bei
                Gabriele Buhl. Ich absolvierte u.a. die Module „Touch for Health I–IV",
                „Brain Gym", Pädagogische Kinesiologie: Gehirnbalancen I–II und
                frühkindliche Reflex-Integration, erweiterte Balancetechniken und die
                „HKC"-Methode.
              </p>
              <p>
                Neben meinem Beruf als Lehrerin begleite ich nun in meiner Praxis{" "}
                <span className="text-stone-900 font-medium">„Zielbalance"</span> Kinder,
                Jugendliche und Erwachsene dabei, Blockaden zu lösen und ihr Potential
                zu entfalten.
              </p>
              <p>
                Die Kinesiologie nutzt den sanften Muskeltest, um Themen sichtbar zu
                machen, die im Körper gespeichert sind. Mit den passenden
                Balancetechniken unterstützen wir Deine natürlichen
                Selbstregulationskräfte – zur Unterstützung Deiner Gesundheit und für
                mehr Leichtigkeit beim Lernen und im Alltag.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-4 max-w-md">
              {[
                ["Qualifikation", "Päd. Kinesiologin"],
                ["Beruf", "Lehrerin (GS)"],
                ["Standort", "Waldburg"],
                ["Setting", "1:1 Sitzungen"],
              ].map(([k, v]) => (
                <div key={k}>
                  <p className="text-[10px] text-sage-700 tracking-[0.25em] uppercase font-medium mb-1">{k}</p>
                  <p className="text-stone-900 text-sm font-medium">{v}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
